import { createFileRoute } from "@tanstack/react-router";

import { prefetchForProject } from "../../../lib/prefetch";
import { Worlds } from "./-worlds";
import { parseWorldsFilters } from "../../../workspaces/worlds/search";

export const Route = createFileRoute("/_console/p/$org/$project/simulate/")({
  validateSearch: parseWorldsFilters,
  loader: ({ context: { queryClient }, params }) =>
    prefetchForProject(
      queryClient,
      params,
      import("../../../workspaces/worlds/queries"),
      ({ worldListQueries }, projectId) => {
        const reads = worldListQueries(projectId);
        void queryClient.prefetchQuery(reads.environments);
        void queryClient.prefetchQuery(reads.scenes);
        void queryClient.prefetchInfiniteQuery(reads.objects(undefined));
      },
    ),
  component: WorldsIndexRoute,
});

/** Every simulation asset, with none inspected. */
function WorldsIndexRoute() {
  return <Worlds state={Route.useSearch()} />;
}
